import { ShapeType } from '@src/slide/infrastructure/module/dependent/shape-info/graphic-type';

export const getTextRect = (component, shapeInfo, size) => (component.operatingGraphicInfo?.textRect
    ?? shapeInfo.getTextRect?.(size.width, size.height));

export const getDefaultTextRect = (element, size?) => {
    const { bgShape, width, height } = element.props.style;

    const style = {
        width: size ? size.width : width,
        height: size ? size.height : height,
    };

    // 对应矩形和文本框，返回默认数据
    if (bgShape === ShapeType.rect) {
        return {
            width: style.width,
            height: style.height,
            left: 0,
            top: 0,
        };
    }

    return getTextRect(element, element.pathParser, style);
};
